lk-google-map #map{
    height: 480px;
} 

lk-google-map .external-link {
    margin-bottom: 1rem;
    display: block;
    line-height: 2.1;
}